import { HttpServiceResponse } from '../../shared'
import AbstractProvider from '../../shared/abstract.provider'
import { AccEntryViewTypes } from '../models/accEntry.types'

export class AccEntryViewProvider extends AbstractProvider {
  urlPath = 'acc_entry_view_api'

  public view<T>(page: AccEntryViewTypes, params: Record<string, any>): Promise<HttpServiceResponse<T>> {
    const query = this.query.stringify({
      ...(page ? { page } : {}),
      ...params,
    })

    return this.http.get(`${this.url}?${query}`)
  }
}
